import { Button, Select, Grid, Tabs, Accordion, TableContainer, TableCell, TableRow, Paper } from "@mui/material";
import { Box, styled as MuiStyled } from "@mui/system";
import { Chip } from "@mui/material";
import { deviceSpec } from "breakpoints";
import styled, {css} from "styled-components";


export const AlertDetailsRoundButton = {
  color: "white",
  borderColor: "white",
  borderRadius: "25px",
  fontSize: "12px",
  height: "30px",
};

export const sectionBorder = {
  borderColor: "#808080",
  borderStyle: "solid",
  borderWidth: "0 0 0.5px 0",
};

export const hidden = css`
  display: none;
`;

export const AlertDetailsContainer = styled(Accordion)`
  #panel1-header {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  #panel1-header:focus {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  > div:not(:last-child) {
    // border-bottom: 1px solid #808080;
  }

  th {
    word-break: break-word;
  }
`

export const ControlContainer = styled('span')`
  display: flex;
  flex-direction: column;
`

export const ControlDetail = styled('div')`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  p {
    font-weight: 600;
    border: 1px solid;
    border-radius: 10%;
    margin: 0 8px 16px 0;
  }
`

export const IOCRowStyle = styled(TableRow)`
  td {
    min-width: max-content;
    word-break: initial;
  }
`

export const IOCMoreRow = styled(TableRow)`
  span {
    color: ${({theme}) => theme.colors.textColor} !important;
  }

  td:nth-child(even) {
    flex-grow: 3 !important;
    max-width: 80%;
    word-wrap: anywhere;
  }

  td:nth-child(odd) {
    flex-grow: 1 !important;
    max-width: 20%;
  }
`

export const IOCMoreCell = styled(TableCell)`
  border-bottom: none !important;
`

export const AlertSummaryContainer = MuiStyled(Grid)`
  display: flex;
  flex-direction: column;
  padding: 32px;
  height: initial;
  align-content: baseline;
  background
  
  &>div {
    padding: 16px 0px;
  }

  @media ${deviceSpec.isMobile} {
    &>div, > span {
      word-break: break-word;
      width: 100%;
      padding: 16px 0px;
    }
  }


  .prism-code {
    p, span, h1, h2, h3, h4, h5, td, a, button, code {
      word-wrap: break-word;
      word-break: break-word;
      font-family: neulis-sans, sans-serif;
      color: white;
      font-size: 100%;
    }
  }

  code {
    color: inherit;
  }

  a {
    color: #1976d2;
  }
`;

export const leftAndRightAlignedContainer = {
  ".MuiGrid-item:first-of-type": {
    width: "50%",
  },
  ".MuiGrid-item:last-of-type": {
    width: "50%",
    textAlign: "right",
  },
};

export const ActionsContainer = MuiStyled(Grid)({
  ...leftAndRightAlignedContainer,
});

export const UserDetailsGrid = MuiStyled(Grid)`
  height: 134px;
  div.MuiGrid-item {
    padding: 24px 0;
    width: 33.3333%;x
    height: 100%;
    border-color: #808080;
    border-width: 1px;
    border-style: solid;
    padding: 12px;
  }

  span {
    display: block;
    height: 24px;
    overflow-wrap: break-word;
  }

  span:nth-child(odd) {
    font-weight: 600;
  }
`;

export const TabContainer = styled(Tabs)`
  .MuiTabs-flexContainer {
    display: flex;

    .MuiButtonBase-root {
      flex-grow: 1;
    }
  }
`

export const FeedbackStyle = styled('div')`
  position: absolute;
  right: 0;
  display: flex;
`

export const TagsContainer = MuiStyled(Grid)({
  ...sectionBorder,
  ...leftAndRightAlignedContainer,

  display: "flex",
  flexDirection: "column",

  ".title": {
    height: "32px",
    fontSize: "20px",
  },
});

export const TextContainer = MuiStyled(Grid)`
  span: {
    display: block;
  }
  
  span:first-of-type {
    height: 32px;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .key-names {
    opacity: 0.75;
  }

  @media ${deviceSpec.isMobile} {
    .MuiButtonBase-root {
      height: min-content;
      padding: 8px !important;
      word-break: break-word;
    }
  }

  margin-top: 0;
  margin-left: 0;
`;

export const MarkdownContainer = styled.div`
  > div {
    display: flex;
    flex-direction: column;

    p, li {
      display: flex;
      flex-direction: row;
    }

    > div {
      display: flex;
      flex-direction: column;
    }
  }
  h1 {
    font-size: ${({ theme }) => theme.font.large} !important;
  }
  
  h2 {
    font-size: ${({ theme }) => theme.font.large};
  }

  h3 {
    font-size: ${({ theme }) => theme.font.large};
  }

  p, pre, li {
    font-size: ${({ theme }) => theme.font.medium};
    margin-top: ${({ theme }) => theme.font.small};
    border: none;
  }

  code {
    display: block;
    font-size: ${({ theme }) => theme.font.medium};
    margin-left: 2em;
  }
  
  li, p {
    // display: flex;
    // display: list-item;
    flex-wrap: wrap;
    // align-items: center;
    margin: 0.25em;

    code {
      margin: 0 0.5em;
    }
  }
`;

export const CloudFormation = styled.div`
  white-space: pre-wrap;
  
  div li {
    flex-direction: column;
  }

  li {
    list-style: circle;
    // display: list-item !important;
    display: flex !important;
    flex-direction: row;
    // flex-wrap: initial;
    
    code {
      margin: 0.25 0;
    }

    p {
      display: contents;
    }
  }

  // li::before {
  //   content: '•';
  //   margin-right: 0.5rem;
  // }

  pre {
    margin: 0;
  }
`

export const TerraformContainer = styled.div`
  li {
    list-style: circle;
    // display: list-item !important;
    display: flex !important;
    flex-direction: row;

    code {
      margin: 0.25 0;
    }

    p {
      display: contents;
    }
  }

  // li::before {
  //   content: '•';
  //   margin-right: 0.5rem;
  // }

  pre {
    margin: 0;
  }
`

export const AWSCLIContainer = styled(Paper)`
  white-space: pre-wrap;
  font-size: 0.9em;
  color:  ${({ theme }) => theme.colors.white};

  font-size: 1em;
  margin: 0.3em 0.25em;
`

// Modified to prevent ResizeObserver errors
export const CommentsContainer = MuiStyled('div')({
  ...leftAndRightAlignedContainer,
  width: '100%',
  ".MuiInputBase-input": {
    fontSize: '14px'
  }
});

export const ActionButtonsContainer = MuiStyled(Grid)`
  ${sectionBorder}
`

export const ControlsDetailContainer = styled.div`
`

export const CommentDetailContainer = MuiStyled('div')`
  display: flex;
  flex-direction: row;
  padding: 12px 0;
  transition: transform 330ms ease-in-out;
  
  span {
    verticalAlign: middle;
  }

  .MuiGrid-item {
    marginBottom: 8px;
  }
`;


export const CommentDetailContainerData = MuiStyled('div')`
  display: flex;
  flex-direction: column;
  span {
    margin-bottom: .5em;
  }
`;

export const CommentDetailHeader = MuiStyled(Grid)({
  ...leftAndRightAlignedContainer,
  ".MuiGrid-item": {
    height: "32px",
  },
  paddingBottom: "16px",
  span: {
    fontSize: "20px",
  },
});

export const ViewAllContainer = MuiStyled(Grid)({
  ...sectionBorder,
  width: "100%",
  "div.MuiGrid-item": {
    paddingTop: "12px",
    paddingBottom: "16px",
    textAlign: "end",
    width: "100%",
  },
});

export const RelatedAlertsContainer = styled.div`
  ${sectionBorder}
  width: 100%;
  background-color: transparent;
  table {
    background-color: transparent;
    min-width: unset;
    border-width: 1px;
    border-style: solid;
    border-color: #5e5e5e;
    min-width: initial;
  }
  thead {
    background-color: #5e5e5e;
    min-width: auto;
    th {
      padding-left: 16px;
      font-size: 14px;
      font-weight: normal;
    }
  }
  tbody {
    min-width: auto;
  }
  tbody td span {
    color: white;
  }
`;

export const IocsTableContainer = styled(TableContainer)`
  td, th {
    width: 20%;
  }
`;


export const PanelContainer = styled(Box)``;
export const TagChip = styled(Chip)``

/************ Components **********/

export const ClearIconContainer = styled(Button)`
  min-width: fit-content;
  svg {
    // color: white;
  }
  svg:hover {
    color: red;
  }
`

export const MoreDetailsButton = MuiStyled(Button)({
  ...AlertDetailsRoundButton,
  "&:hover": {
    borderColor: "white",
  },
});

export const NewCommentInputContainer = MuiStyled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 0.5em;
  
  .MuiInputBase-root {
    height: auto;
    box-shadow: inset 1.1px 1px 3.2px hsl(0deg 0% 0% / 0.47);
  }
`;

export const NewCommentButton = styled(Button)`
  border-radius: 4px;
  font-size: 12px;
  height: 30px;
  width: max-content;
  margin: 16px 0 !important;
  align-self: start;
  :hover: {
    borderColor: white;
  }
`;

export const ReprocessButton = styled(Button)`
  background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.lightButton : theme.colors.lightButton} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  text-transform: none;
  padding: 10px 20px !important;
  font-weight: 555 !important;
  font-size: 14px !important;
  min-width: max-content !important;
  margin-top: 25px !important;

  svg {
    min-width: 20px;
    min-height: 20px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.name === 'light-theme' ? theme.colors.sidebarLightHover : theme.colors.sidebarLightHover} !important;
    box-shadow: 0 4px 12px rgba(161, 0, 255, 0.3);
  }
`;

export const TagsButton = MuiStyled(Button)({
  color: "#ffffff",
  borderRadius: "8px",
  border: "none",
  padding: "8px 24px",
  fontSize: "14px",
  textTransform: "none",
  fontWeight: 500,
  marginBottom: "12px",
  height: "38px",
  "&:hover": {
    backgroundColor: "#8a00e6",
  },
});

export const ActivityTitleSpan = styled.span`
  font-size: 16px;
  display: block;
  margin-top: 16px;
`;

export const PrimaryButtonRounded = MuiStyled(Button)({
  color: "white",
  borderRadius: "10px",
  height: "24px",
});

export const PrimaryButtonRectangle = MuiStyled(Button)({
  color: "white",
  height: "32px",
  fontWeight: "500",
});

export const ActionsSelect = MuiStyled(Select)({
  height: "30px",
  borderRadius: "25px",
  borderColor: "white",
  borderStyle: "solid",
  borderWidth: "1px",
  padding: "0 10px",
  marginRight: "16px",
  "&:hover": {
    borderColor: "white",
  },
  fieldset: {
    border: "none",
  },
});

export const AccessButton = MuiStyled(Button)({
  color: "white",
  borderRadius: "20px",
  height: "30px",
});

export const CommentSpan = styled.span`
  font-size: 14px;
`;

interface DefaultUserCircleProps {
  backgroundColor: string;
}

export const DefaultUserCircle = styled.p<DefaultUserCircleProps>`
  width: 3em;
  height: 3em;
  background-color: ${props => props.backgroundColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: bold;
  margin-right: 1.5em;
`;

export const RelatedAlertsTitle = styled.div`
  font-size: 20px;
  height: 32px;
  margin-bottom: 12px;
`;

export const AssignedToDropdown = MuiStyled(Select)({
  height: "30px",
  borderRadius: "25px",
  borderColor: "white",
  borderStyle: "solid",
  borderWidth: "1px",
  padding: "0 10px",
  fieldset: {
    border: "none",
  },
  "&:hover": {
    borderColor: "white",
  },
});

export const CloseBtnContainer = styled("span")`
  padding: 0 !important;

  .MuiButtonBase-root {
    position: absolute;
    z-index: 10000;
    right: 1em;
    top: 3em;
  }

  @media ${deviceSpec.isTablet} {
    top: 0.5em;
    right: 0.5em;
  }
`;

export const CloseBtn = styled(Button)({
  justifyContent: "flex-end",
  display: "flex",
  alignItems: "flex-end",
  textAlign: "right",
});

export const UserInputContainer = styled("span")`
  .MuiInputBase-root, .MuiButtonBase-root {
    height: auto;
  }

  .MuiIFormControl-root {
    label {
      top: 0 !important;
    }

    box-shadow: inset 1.1px 1px 3.2px hsl(0deg 0% 0% / 0.47)
  }
`;